import { useState } from 'react';
import toLower from 'lodash/toLower';

import { useQueryClusters } from '@ion/api';

export default function useClustersTabConfig() {
  const { data: clusters, loading: loadingClusters } = useQueryClusters();
  const [searchTerm, setSearchTerm] = useState('');

  const handleClusterSearch = event => {
    if (!event || !event.target) {
      return;
    }

    setSearchTerm(event.target.value);
  };

  const displayedClusters = searchTerm
    ? clusters.filter(({ name }) => toLower(name).includes(toLower(searchTerm)))
    : clusters;

  return {
    loadingClusters,
    displayedClusters,
    handleClusterSearch,
  };
}
